<div class="border border-outline dark:border-outline-darkmode rounded-md @container">
  <div class="py-16.5 @xl:py-40 px-6 @lg:px-24 flex flex-col items-center justify-center gap-6">
    <div class="flex justify-center">
      <div
        class="bg-success-soft dark:bg-success-soft-darkmode rounded-lg size-16 flex items-center justify-center text-on-success-soft dark:text-on-success-soft-darkmode"
      >
        <ui-loading-spinner size="20" />
      </div>
    </div>
    <div class="flex flex-col gap-2 text-center">
      <h1 class="text-lg font-semibold leading-7">
        {{ 'cockpit.parseRequests.createSuccess.title' | transloco }}
      </h1>
      <p class="text-sm leading-6 font-semibold">
        {{ 'cockpit.parseRequests.createSuccess.subtitle' | transloco }}
      </p>
      <p class="text-sm leading-6">
        {{ 'cockpit.parseRequests.createSuccess.description' | transloco }}
      </p>
    </div>
    <div class="flex flex-col gap-4 items-center w-full max-w-[348px]">
      <ui-alert expand="full" class="w-full" [titleOnly]="true" color="success">
        <ng-icon name="heroCheck" size="20" slot="icon" class="!block" />
        <h2 slot="title">
          {{ 'cockpit.parseRequests.createSuccess.summary.processed' | transloco }}
        </h2>
      </ui-alert>
      <ui-alert expand="full" class="w-full" [titleOnly]="true">
        <ng-icon name="heroAdjustmentsHorizontal" size="20" slot="icon" class="!block" />
        <h2 slot="title">
          {{ 'cockpit.parseRequests.createSuccess.summary.analyzing' | transloco }}
        </h2>
      </ui-alert>
      <ui-alert expand="full" class="w-full" [titleOnly]="true">
        <ng-icon name="heroDocumentMagnifyingGlass" size="20" slot="icon" class="!block" />
        <h2 slot="title">
          {{ 'cockpit.parseRequests.createSuccess.summary.checking' | transloco }}
        </h2>
      </ui-alert>
    </div>
    <div class="flex flex-col gap-2 text-center">
      <p class="text-sm leading-6 font-semibold">
        {{ 'cockpit.parseRequests.createSuccess.infoHint' | transloco }}
      </p>
      <p class="text-sm leading-6">
        {{ 'cockpit.parseRequests.createSuccess.contactTextPrefix' | transloco }}
        <a
          [href]="'/organizations/' + organizationId() + '/dashboard?showContactDialog=true'"
          target="_blank"
          class="text-primary dark:text-primary-darkmode underline cursor-pointer"
          >{{ 'cockpit.parseRequests.createSuccess.contactLink' | transloco }}</a
        >
        {{ 'cockpit.parseRequests.createSuccess.contactTextSuffix' | transloco }}
      </p>
      <p>&nbsp;</p>
      <p class="text-sm leading-6">
        {{ 'cockpit.parseRequests.createSuccess.statusHint' | transloco }}
      </p>
    </div>
  </div>
  <div class="px-6 pb-4 flex justify-end gap-3 @container">
    <div class="flex-1">
      <ui-button
        mode="outlined"
        class="hidden @xl:inline"
        [routerLink]="['/organizations', organizationId(), 'dashboard']"
      >
        <ng-icon name="heroSquares2x2" size="20" slot="start" class="!block" />
        {{ 'cockpit.parseRequests.createSuccess.buttonDashboard' | transloco }}
      </ui-button>
      <ui-button
        mode="outlined"
        [iconOnly]="true"
        class="@xl:hidden"
        [ariaLabel]="'cockpit.parseRequests.createSuccess.buttonDashboard' | transloco"
        [routerLink]="['/organizations', organizationId(), 'dashboard']"
      >
        <ng-icon name="heroSquares2x2" size="20" class="!block" />
      </ui-button>
    </div>
    <ui-button
      mode="outlined"
      class="hidden @xl:inline"
      [routerLink]="['/organizations', organizationId(), 'parse-requests', parseRequestId()]"
    >
      <ng-icon name="heroDocumentText" size="20" slot="start" class="!block" />
      {{ 'cockpit.parseRequests.createSuccess.buttonDetails' | transloco }}
    </ui-button>
    <ui-button
      mode="outlined"
      [iconOnly]="true"
      class="@xl:hidden"
      [ariaLabel]="'cockpit.parseRequests.createSuccess.buttonDetails' | transloco"
      [routerLink]="['/organizations', organizationId(), 'parse-requests', parseRequestId()]"
    >
      <ng-icon name="heroDocumentText" size="20" class="!block" />
    </ui-button>
    <ui-button
      [routerLink]="['/organizations', organizationId(), 'supplier-contracts']"
      [queryParams]="{
        parseRequestCreated: parseRequestId(),
      }"
    >
      {{ 'cockpit.parseRequests.createSuccess.buttonMyContracts' | transloco }}
      <ng-icon name="heroArrowRight" size="20" slot="end" class="!block" />
    </ui-button>
  </div>
</div>
